export const videos = [
  {
    id: 1,
    title: '星际穿越：人类最后的希望',
    category: 'movie',
    categoryName: '电影大片',
    duration: '02:49:00',
    views: '2,580万',
    rating: 9.4,
    image: 'https://readdy.ai/api/search-image?query=Epic%20space%20science%20fiction%20movie%20scene%20with%20massive%20black%20hole%20and%20distant%20galaxy%2C%20astronaut%20spacecraft%20approaching%20event%20horizon%2C%20cinematic%20dramatic%20lighting%20with%20warm%20orange%20and%20deep%20blue%20tones%2C%20IMAX%20quality%20visual%20effects%20composition&width=800&height=450&seq=video-1&orientation=landscape',
    description: '克里斯托弗·诺兰执导的科幻巨制，讲述人类穿越虫洞寻找新家园的史诗旅程。',
    slug: 'interstellar-hope',
  },
  {
    id: 2,
    title: '长安十二时辰：危机四伏',
    category: 'tv',
    categoryName: '电视剧集',
    duration: '00:45:00',
    views: '1,820万',
    rating: 8.9,
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20cityscape%20at%20night%20with%20thousands%20of%20lanterns%20illuminating%20traditional%20architecture%2C%20bustling%20market%20streets%20and%20grand%20palace%20gates%2C%20cinematic%20historical%20drama%20atmosphere%20with%20warm%20golden%20and%20red%20tones%2C%20epic%20wide%20shot%20composition&width=800&height=450&seq=video-2&orientation=landscape',
    description: '唐朝长安城十二时辰内发生的惊心动魄的悬疑故事。',
    slug: 'changan-crisis',
  },
  {
    id: 3,
    title: '奔跑吧兄弟：特别季',
    category: 'variety',
    categoryName: '综艺节目',
    duration: '01:30:00',
    views: '3,100万',
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Energetic%20outdoor%20variety%20show%20scene%20with%20colorful%20obstacle%20course%20and%20cheering%20crowd%2C%20sunny%20day%20with%20bright%20blue%20sky%2C%20fun%20competitive%20games%20atmosphere%2C%20warm%20vibrant%20colors%20and%20dynamic%20action%20photography%20with%20joyful%20energy&width=800&height=450&seq=video-3&orientation=landscape',
    slug: 'running-bro-special',
  },
  {
    id: 4,
    title: '进击的巨人：最终章',
    category: 'anime',
    categoryName: '动漫动画',
    duration: '00:24:00',
    views: '4,500万',
    rating: 9.6,
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20anime%20battle%20scene%20with%20giant%20humanoid%20figures%20and%20flying%20soldiers%20with%20gear%2C%20smoke%20filled%20sky%20with%20golden%20sunset%20light%2C%20intense%20action%20composition%2C%20cinematic%20illustration%20style%20with%20rich%20warm%20and%20cool%20color%20contrast&width=800&height=450&seq=video-4&orientation=landscape',
    slug: 'attack-titan-final',
  },
  {
    id: 5,
    title: '地球脉动：蓝色星球',
    category: 'documentary',
    categoryName: '纪录片',
    duration: '00:52:00',
    views: '1,350万',
    rating: 9.7,
    image: 'https://readdy.ai/api/search-image?query=Stunning%20underwater%20ocean%20scene%20with%20coral%20reef%20teeming%20with%20colorful%20marine%20life%2C%20sunlight%20beams%20penetrating%20clear%20turquoise%20water%2C%20sea%20turtles%20and%20schools%20of%20fish%2C%20nature%20documentary%20cinematography%20with%20vibrant%20natural%20colors%20and%20ethereal%20lighting&width=800&height=450&seq=video-5&orientation=landscape',
    slug: 'planet-earth-blue',
  },
  {
    id: 6,
    title: '周杰伦嘉年华世界巡回演唱会',
    category: 'music',
    categoryName: '音乐MV',
    duration: '02:15:00',
    views: '5,200万',
    rating: 9.5,
    image: 'https://readdy.ai/api/search-image?query=Spectacular%20music%20concert%20stage%20with%20massive%20LED%20screen%20and%20elaborate%20lighting%20rig%2C%20crowd%20holding%20phone%20lights%20creating%20ocean%20of%20stars%2C%20warm%20golden%20and%20purple%20stage%20lights%2C%20epic%20live%20performance%20photography%20with%20dramatic%20atmosphere&width=800&height=450&seq=video-6&orientation=landscape',
    slug: 'jay-carnival-tour',
  },
  {
    id: 7,
    title: '哪吒之魔童降世',
    category: 'anime',
    categoryName: '动漫动画',
    duration: '01:50:00',
    views: '6,800万',
    rating: 9.2,
    image: 'https://readdy.ai/api/search-image?query=Mythological%20Chinese%20animated%20film%20scene%20with%20dramatic%20cloud%20formations%20and%20fire%20elements%2C%20powerful%20character%20standing%20amidst%20swirling%20red%20and%20gold%20energy%2C%20epic%20fantasy%20atmosphere%2C%20cinematic%20digital%20art%20with%20vibrant%20warm%20colors%20and%20dynamic%20composition&width=800&height=450&seq=video-7&orientation=landscape',
    slug: 'nezha-movie',
  },
  {
    id: 8,
    title: '三体：黑暗森林',
    category: 'tv',
    categoryName: '电视剧集',
    duration: '00:50:00',
    views: '2,900万',
    rating: 9.1,
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20cosmic%20scene%20with%20three%20suns%20in%20alien%20sky%2C%20desolate%20landscape%20with%20strange%20rock%20formations%2C%20dramatic%20sci-fi%20atmosphere%20with%20deep%20blues%20and%20warm%20orange%20sunlight%2C%20cinematic%20science%20fiction%20composition%20with%20ethereal%20lighting&width=800&height=450&seq=video-8&orientation=landscape',
    slug: 'three-body-dark-forest',
  },
  {
    id: 9,
    title: '泰坦尼克号：25周年纪念',
    category: 'movie',
    categoryName: '电影大片',
    duration: '03:14:00',
    views: '3,400万',
    rating: 9.3,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20ocean%20liner%20ship%20deck%20scene%20at%20sunset%20with%20golden%20hour%20lighting%2C%20elegant%20couple%20silhouette%20against%20warm%20sky%2C%20calm%20ocean%20with%20reflections%2C%20nostalgic%20cinematic%20atmosphere%20with%20rich%20warm%20amber%20and%20rose%20gold%20tones&width=800&height=450&seq=video-9&orientation=landscape',
    slug: 'titanic-anniversary',
  },
];

export const featuredVideos = videos.slice(0, 6);
export const trendingVideos = [videos[0], videos[3], videos[5], videos[6], videos[8], videos[1]];